module.exports = __webpack_public_path__ + "media/images/bank_images/unibanco-f2a57b4af5eef380b4fbfcecbb85a0d7.png";